var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8392_30753)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92799 1.71429C5.98121 1.71429 5.2137 2.4818 5.2137 3.42857V4.28571H8.64227V3.42857C8.64227 2.4818 7.87476 1.71429 6.92799 1.71429ZM3.49942 3.42857V4.28571H3.07087C2.36079 4.28571 1.78516 4.86135 1.78516 5.57143V10.7143C1.78516 11.4243 2.36079 12 3.07087 12H10.7852C11.4952 12 12.0709 11.4243 12.0709 10.7143V5.57143C12.0709 4.86135 11.4952 4.28571 10.7852 4.28571H10.3566V3.42857C10.3566 1.53502 8.82154 0 6.92799 0C5.03444 0 3.49942 1.53502 3.49942 3.42857ZM6.92801 9.21429C7.51975 9.21429 7.99944 8.73463 7.99944 8.14286C7.99944 7.55112 7.51975 7.07143 6.92801 7.07143C6.33628 7.07143 5.85658 7.55112 5.85658 8.14286C5.85658 8.73463 6.33628 9.21429 6.92801 9.21429Z",
    fill: "#9D96AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8392_30753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.a0131171428f2c064f5a2f527ade3ce7.svg";
export { ForwardRef as ReactComponent };